import { connect } from 'react-redux';
import ModalCommentForm from './ModalCommentForm';
import { addComment } from '../../../redux/actions';

const mapDispatchToProps = {
  onSubmit: addComment,
};

export default connect(null, mapDispatchToProps)(ModalCommentForm);
